import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import axios from "axios";
import React, { memo, useEffect, useState } from "react";
import { useStyle } from "../style";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
const PurchaseInfo = ({setPostData,postData,setDocName , docName}) => {
  const classes = useStyle();
  const[supplierData,setSupplierData]=useState([])
  const [address , setAddress] = useState("")
  const [gstIn , setGstIn] = useState("")
  const dispatch = useDispatch()
  const [poDetails , setPoDetails] = useState({
    poNo:"",
    poDate:moment().format(),
    docDate:moment().format(),
    partyNo:"",
    dcDate:moment().format(),
    supplierId:null,
  })
  const [balance , setBalance] = useState('0.00')
  const getSupplierData = () => {
    axios.get(`/v1/supplier`)
    .then((res) => {
      setSupplierData(res.data)
    })
    .catch((err) => {console.log(err);dispatch(setSnackbar(true,'error',err.response.data.error))})
  }
  const getPurchaseData = () => {
    axios.get(`/v1/purchase`)
    .then((res) => {
      setDocName(res.data.Docno)
    })
    .catch((err) => {
      console.log(err)
      dispatch(setSnackbar(true,'error',err.response.data.error))
    })
  }
  const handleSupplierChange = (event, value) => {
    // formik.setFieldValue("supplier" , value)
    const selectedSupplier = supplierData.find((supplier) => supplier.name === value?.name);
    console.log(selectedSupplier)
    setAddress(selectedSupplier ?  (selectedSupplier.add1 + " " + selectedSupplier.add2 + "," + selectedSupplier.city_name + "-" + selectedSupplier.pincode + "-" + selectedSupplier.state_name + "-" + selectedSupplier.country_name ) : '') // Update this based on your actual data structure
    setGstIn(selectedSupplier ? selectedSupplier.gstin : "")
    setBalance(selectedSupplier ? selectedSupplier.balance  : 0.00)
    setPoDetails((prevState) =>( {...prevState , supplierId:value}))
  };
  const handleChange =(e, name) => {
    if(name==='poDate' || name==='docDate' || name==='dcDate'){
      setPoDetails((prevState) =>( {...prevState ,  [name] : dayjs(e).format() }))
    }else{
      setPoDetails((prevState) =>( {...prevState , [name] :  e}))
    }
      
  }
  useEffect(() => {
    getSupplierData() // suplier name
    getPurchaseData() // purchase doc name
  },[])
  useEffect(() => {
    const obj = {
      pono:poDetails.poNo,
      podate:moment(poDetails.poDate).format('YYYY/MM/DD')
    }
    const arr=[obj]
    const objData = {...postData}
    const arrData =[...objData.purchase_details]
    if(arrData.length > 0){
      arrData.map(item => ({ ...item, docdate: moment(poDetails.docDate).format('YYYY/MM/DD') }))
      setPostData((prevState)=>({...prevState, purchase_details : arrData}))
    }
 setPostData((prevState)=>({...prevState,  po_details: arr , docdate:moment(poDetails.docDate).format('YYYY/MM/DD') ,partydc:poDetails.partyNo,partydcdate:moment(poDetails.dcDate).format('YYYY/MM/DD'),company_id:1,partycode:poDetails.supplierId !== null ? poDetails.supplierId.id : "",gst_per:0,cess_per:0,outstanding:0}))
//  partycode:formik.values.supplier.id,
  },[poDetails])
  return (
    <Grid container spacing={2} className="p-2 h-full" >
        <Grid item lg={4} >
  
          {/* <label for="datepicker">Select a date:</label>
          <br />
          <input  type="date" id="datepicker" class="date-input" ></input> */}
        <Autocomplete
          id="supplier"
          name="supplier"
          size="small"
          options={supplierData}
          getOptionLabel={(option) => option?.name}
          value={poDetails.supplierId}
          onChange={handleSupplierChange}
          disableClearable
          isOptionEqualToValue={(option, value) =>
            option.name === value.name
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Supplier Name"
              autoComplete="off"
              // required
            />
          )}
  />
        <TextField size="small" label='Address'  multiline rows={3.3} fullWidth sx={{marginBlock:1.5}} value={address} InputProps={{ readOnly: true }}/>
        <TextField size="small" label='GSTIN' fullWidth  value={gstIn} InputProps={{ readOnly: true }}/>
        </Grid>
        <Grid item lg={4}>
        <TextField size="small" label='PO No' fullWidth onChange={(e)=>handleChange(e.target.value,'poNo')} required/>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker onChange={(e)=>handleChange(e,'poDate')} value={dayjs(poDetails.poDate)} label="PO Date" slotProps={{
                  textField: {
                    size: "small",
                    label:'PO Date'
                  },
                }}
                sx={{width: '100%',marginBlock:1.5}}
                />
        </LocalizationProvider>
        {/* <TextField size="small" label='PO Date' fullWidth sx={{marginBlock:1.5}}/> */}
        <TextField size="small" label='PartyDc/Inv No' onChange={(e)=>handleChange(e.target.value,'partyNo')} fullWidth sx={{marginBottom:1.5}} required/>
        {/* <TextField size="small" label='Dc/Inv Date' fullWidth /> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker onChange={(e)=>handleChange(e,'dcDate')} value={dayjs(poDetails.dcDate)} label="Dc/Inv Date" slotProps={{
                  textField: {
                    size: "small",
                  },
                }}
                sx={{width: '100%'}}
                />
        </LocalizationProvider>
        </Grid>
        <Grid item lg={4}>
          <TextField size="small" label='Bill No' fullWidth  value={docName} InputProps={{ readOnly: true }}/>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker  onChange={(e)=>handleChange(e,'docDate')} value={dayjs(poDetails.docDate)} label="Bill Date" slotProps={{
                          textField: {
                            size: "small",
                          },
                        }}
                        sx={{width: '100%',marginBlock:1.5}}
                        />
          </LocalizationProvider>
              {/* <TextField size="small" label='Doc Date' fullWidth sx={{marginBlock:1.5}}/> */}
          <Typography textAlign="center" variant="h6" sx={{backgroundColor:'#83A2FF',}}>Balance</Typography>
          <Typography textAlign='right' variant="h5" mt={1} sx={{fontWeight:600,}} >{balance}</Typography>
        </Grid>
    </Grid>
  );
};
export default memo(PurchaseInfo);